function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsInspections = function SvgSettingsInspections(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,32.09l-5.51-5.51a6.84,6.84,0,0,0-.9-8.55,6.65,6.65,0,0,0-9.42-.15A1,1,0,0,0,18,18a6.65,6.65,0,0,0-.15,9.41l.15.15a6.83,6.83,0,0,0,8.55.9L32.09,34Zm-14.4-6a4.47,4.47,0,0,1-.07-6.33l.07-.08a4.48,4.48,0,0,1,6.34-.07l.07.07a4.48,4.48,0,0,1,.08,6.34l-.08.07A4.57,4.57,0,0,1,19.6,26.12Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsInspections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-inspections.ec8646df.svg";
export { ForwardRef as ReactComponent };